{
    "rapormusteri": {
        "Baslik": "Müşteri Raporu",
        "Musteri": "Müşteri",
        "Referans": "Referans",
        "Kullanici": "Kullanıcı",
        "Cep": "Telefon",
        "Cep2": "Telefon 2",
        "Randevu": "Randevu",
        "SatisOnayli": "Onaylı Satış",
        "SatisOnaysiz": "Onaysız Satış",
        "SatisIptal": "İptal Satış",
        "SatisCayma": "Cayma Satış",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "BaslangicTarihi": "Kayıt Başlangıç",
        "BitisTarihi": "Kayıt Bitiş",
        "Islemler": "İşlemler",
        "Duzenle": "Düzenle",
        "Sil": "Sil",
        "Ad": "Ad",
        "Soyad": "Soyad",
        "Cinsiyet": "Cinsiyet",
        "KimlikNo": "TC/Kimlik No",
        "Email": "E-Posta",
        "Email2": "E-Posta 2",
        "Adres": "Adres",
        "Aciklama": "Açıklama",
        "Guncelle": "Güncelle",
        "EminMisiniz": "Emin misiniz?",
        "GeriAlamazsiniz": "Bu işlem geri alınamaz!",
        "EvetSil": "Evet, sil!",
        "Iptal": "İptal",
        "ExcelAktar": "Excel Aktar",
        "MusteriDetay": "Müşteri Detay",
        "Bilgisi": "Bilgisi",
        "Aktarma": "Aktarma",
        "GeciciYetki": "Geçici Yetki",
        "Durum": "Durum",
        "Kilit": "Kilit",
        "Meslek": "Meslek",
        "DogumTarihi": "Doğum Tarihi",
        "HedefKullanici": "Hedef Kullanıcı",
        "Aktar": "Aktar",
        "YetkiVerilecekKullanici": "Yetki Verilecek Kullanıcı",
        "YetkiVer": "Yetki Ver",
        "VerilenYetkiler": "Verilen Yetkiler",
        "KayitBulunamadi": "Kayıt bulunamadı.",
        "Il": "İl",
        "Ilce": "İlçe",
        "Olusturma": "Oluşturma",
        "SonGuncelleme": "Son Güncelleme",
        "TasimaAciklama": "Seçilen müşterinin tüm kayıtları hedef müşteriye aktarılacak ve mevcut müşteri silinecektir.",
        "HedefMusteri": "Hedef Müşteri",
        "Tasi": "Taşı",
        "MevcutMusteriKodu": "Mevcut Müşteri Kodu",
        "Onsekizalti": "18 Yaş Altı",
        "SigortaEttiren": "Sigorta Ettiren"
    }
}
